import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { widgetActions } from '../../store/modules/widget';
import WidgetHomeMenuWrap from '../../views/widget/homeMenu/WidgetHomeMenuWrap';

const WidgetHomeMenuContainer = () => {
  const homeMenu = useSelector((state) => state.widget.homeMenu);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(widgetActions.requestHomeMenu());
  }, [dispatch]);

  /**
   *  메뉴 변경 저장
   */
  const onSubmit = (values) => {
    dispatch(widgetActions.updateHomeMenu(values));
  };

  return <WidgetHomeMenuWrap homeMenu={homeMenu} onSubmit={onSubmit} />;
};

export default withRouter(WidgetHomeMenuContainer);
